import React from 'react'

import Footer from '../../../componenets/footer/Footer'
import ProjectDetailsContainer from '../../../containers/thrustarea/projectdetails/ProjectDetailsContainer'

function TAProjectDetails() {
  return (
    <div className='listedprojects'>
        <ProjectDetailsContainer />
    </div>
  )
}

export default TAProjectDetails